import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ArchivedEmployeesTable from "./table";
import { query, collection, where, getDocs } from "firebase/firestore";
import { db } from "src/firebase";
import { IEmployee } from "src/types/employees";
import { useRecoilValue } from "recoil";
import { authState } from "src/store/auth";
import { chunkArray } from "src/utils";
import { employeeRoleFlags } from "../add-edit-employee/constants";

const ArchivedEmployeesPage = () => {
  const [archivedUsers, setArchivedUsers] = useState<IEmployee[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const auth = useRecoilValue(authState);
  const { user } = auth;
  const roleType = user?.roleType;
  const locationsIdList = user?.allowedLocationsId ?? [];

  useEffect(() => {
    const fetchActiveUsers = async () => {
      try {
        setIsLoading(true);
        let snapshots = [];
        // Not Admin then apply locations filter with chunking
        if (false) {
          //roleType !== "Admin" && locationsIdList?.length
          const chunks = chunkArray(locationsIdList, 10);

          const queries = chunks.map((chunk) =>
            getDocs(
              query(
                collection(db, "users"),
                where("isUserActive", "==", false),
                where("allowedLocationsId", "array-contains-any", chunk),
              ),
            ),
          );
          snapshots = await Promise.all(queries);
        }
        // Admin then ignore locations
        else {
          const snapshot = await getDocs(
            query(collection(db, "users"), where("isUserActive", "==", false)),
          );
          snapshots = [snapshot]; // keep same structure
        }

        // Deduplicate
        const usersMap = new Map<string, IEmployee>();
        snapshots.forEach((snapshot) => {
          snapshot.docs.forEach((doc) => {
            if (!usersMap.has(doc.id)) {
              usersMap.set(doc.id, {
                ...(doc.data() as IEmployee),
                id: doc.id,
              });
            }
          });
        });

        setArchivedUsers(Array.from(usersMap.values()));
      } catch (error) {
        console.error("Error fetching active users:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchActiveUsers();
  }, [roleType]);

  // Filter out client-only users, as the same user can be both a client and an admin at the same time.
  const archivedEmployees = archivedUsers.filter((user) =>
    employeeRoleFlags.some((role) => user[role]),
  );

  return (
    <Box p={"30px"} data-testid="archived-employees-page">
      <Typography mb={4} fontSize={"22px"} fontWeight={600}>
        Archived Accounts
      </Typography>
      <ArchivedEmployeesTable
        rowsList={archivedEmployees}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default ArchivedEmployeesPage;
